export const ONBOARDING_STEPS = [
  'welcome',
  'passwords',
  'accounts',
  'meals',
  'employee',
  'menu',
  'payments',
  'setup_complete',
  'tutorial',
];

const priceField = value => (
  value === null || value === undefined || value === '' ? '' : String(value)
);

export const createOnboardingDraft = response => {
  const configuration = response?.configuration || {};
  return {
    currentStep: ONBOARDING_STEPS.includes(response?.current_step)
      ? response.current_step
      : 'welcome',
    useCombinedAccounts: Boolean(configuration.use_combined_accounts),
    breakfastLunchEnabled: configuration.is_breakfast_lunch_enabled !== false,
    drinksEnabled: configuration.is_drinks_enabled !== false,
    snacksEnabled: configuration.is_snacks_enabled !== false,
    dinnerEnabled: Boolean(configuration.dinner_enabled),
    defaultLunchPrice: priceField(configuration.default_lunch_price),
    defaultDinnerPrice: priceField(configuration.default_dinner_price),
  };
};

export const getNextOnboardingStep = currentStep => {
  const index = ONBOARDING_STEPS.indexOf(currentStep);
  if (index < 0 || index === ONBOARDING_STEPS.length - 1) return currentStep;
  return ONBOARDING_STEPS[index + 1];
};

export const getPreviousOnboardingStep = currentStep => {
  const index = ONBOARDING_STEPS.indexOf(currentStep);
  if (index <= 0) return currentStep;
  return ONBOARDING_STEPS[index - 1];
};

export const shouldShowDepartmentOnboarding = onboarding => (
  onboarding?.status === 'pending' || onboarding?.status === 'in_progress'
);
